import { Grid } from '@material-ui/core';
import React, { useContext } from 'react'
import SpButton from '../../../components/atoms/SpButton';
import SpText from '../../../components/atoms/SpText';
import { createReport } from '../../../models/actions/Reports';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { useState } from 'react';
import { SpSelect, SpSelectMenuItem } from '../../../components/atoms/SpSelect';
import { withSnackbar } from '../../../components/atoms/SpSnackBar';
import { UserSessionContext } from '../../../App';
import moment from 'moment';

const bikeParts = [
	{
		id: 1,
		value: "Ruote",
	},
	{
		id: 2,
		value: "Freni",
	},
	{
		id: 3,
		value: "Batteria",
	},
	{
		id: 4,
		value: "Display",
	},
	{
		id: 5,
		value: "Motore",
	},
	{
		id: 6,
		value: "Telaio",
	},
	{
		id: 7,
		value: "Chiavi e meccanismi di sicurezza",
	},
];
const bikePartsDetail = [
	{
		id: 1,
		value: "Ruota anteriore",
	},
	{
		id: 2,
		value: "Entrambe le ruote",
	},
	{
		id: 3,
		value: "Ruota posteriore",
	},
];

const StationReportCreateModal = ({setReportCreationOpen, reportCreationOpen},props) => {
    const location = useLocation();
    const [selectedBikePart, setSelectedBikePart] = useState(null);
	const [selectedBikePartDetail, setSelectedBikePartDetail] = useState(null);

    const { authData, setAuthData } = useContext(UserSessionContext);

    const openNewReport = async() => {
        try {
            const userData = location.state?.data;
            const bikePartValue = bikeParts.find((e) => e.id == selectedBikePart).value;
			const bikePartDetailValue = selectedBikePartDetail ? bikePartsDetail?.find((e) => e.id == selectedBikePartDetail).value : "";
            const response = await createReport( { id_user: authData.id, creation_date: moment(), id_rent: reportCreationOpen.rent.id, bike_part: bikePartValue, bike_part_detail: bikePartDetailValue, status: "open" },authData.accessToken);
            setReportCreationOpen((prev)=>({...prev,status:false}));
        } catch (error) {
            //props.snackbarShowErrorMessage(error);
            console.error(error)
            setReportCreationOpen((prev)=>({...prev,status:false}));
        }
    }
  return (
    <Grid
    container
    direction="column"
    spacing={2}
  >
    <Grid
      item
      xs={12}
    >
      <SpText variant="text">{'Vuoi aprire una segnalazione per questo noleggio?'}</SpText>
    </Grid>
    <Grid
      item container direction='row'
      xs={12}
    >
    <Grid
      item
      xs={6}
    >
      <SpSelect
                    value={selectedBikePart}
                    label="Scegli parte di bici"
                    labelColor={'black'}
                    onChange={(e) => {
                      setSelectedBikePart(e.target.value);
                    }}
                  >
                    {bikeParts.map((item) => (
                      <SpSelectMenuItem
                        key={item.id}
                        value={item.id}
                      >
                        {item.value}
                      </SpSelectMenuItem>
                    ))}
                  </SpSelect>
    </Grid>
    <Grid
      item
      xs={6}
    >
      <SpSelect
        value={selectedBikePartDetail}
         label="Scegli dettaglio della parte della bici."
                    labelColor={'black'}
                    onChange={(e) => {
                      setSelectedBikePartDetail(e.target.value);
                    }}
                  >
                    {bikePartsDetail.map((item) => (
                      <SpSelectMenuItem
                        key={item.id}
                        value={item.id}
                      >
                        {item.value}
                      </SpSelectMenuItem>
                    ))}
                  </SpSelect>
    </Grid>
    </Grid>
    <Grid
      item
      container
      xs={12}
      alignItems={'flex-start'}
    >
      <Grid
        item
        xs={4}
      >
        <SpButton
          text={'SI'}
          buttonType="accept"
          onClick={() => openNewReport()}
        />
      </Grid>
      <Grid
        item
        xs={4}
        style={{ marginBottom: '1%' }}
      >
        <SpButton
          text={'NO'}
          buttonType="accept"
          onClick={() => {
            setReportCreationOpen({ rent: null, station: null, bike: null, status: false });
          }}
        />
      </Grid>
    </Grid>
  </Grid>
  )
};

export default withSnackbar(StationReportCreateModal);